/**
 * Calculates the down payment for a listing based on the provided price and payment details.
 *
 * @param {number} price - The listing price of the vehicle.
 * @param {Object} paymentDetails - An object containing payment information.
 * @param {number} [paymentDetails.downPayment=0] - The fixed down payment amount.
 * @param {number} [paymentDetails.downPaymentPercent=0] - The down payment percentage (as a decimal, e.g., 0.1 for 10%).
 * @param {boolean} [priceIncludesDownPayment=true] - Indicates whether the price already includes the down payment.
 * @returns {number} - The calculated down payment amount, rounded to the nearest integer.
 */
const calculateDownPayment = function (price, paymentDetails) {
  let priceIncludesDownPayment = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  const {
    downPayment = 0,
    downPaymentPercent = 0
  } = paymentDetails;
  if (priceIncludesDownPayment) {
    return Math.round(downPayment ?? downPaymentPercent * price);
  }
  return Math.round(downPayment ?? price * downPaymentPercent / (1 - downPaymentPercent));
};
export { calculateDownPayment as default };
